// Schema dati GPS di gara (endpoint /Matches/gpsStats).
// Fase 1: provider unico (schema fisso). In Fase 2 diventerà multi-provider.

export const GPS_FRACTION_OPTIONS = [
	{value: 0, label: "Intera gara"},
	{value: 1, label: "1° tempo"},
	{value: 2, label: "2° tempo"},
];

// Metriche numeriche (key = campo API, label = etichetta, unit = unità)
export const GPS_STAT_METRICS = [
	{key: "totalDistance", label: "Distanza totale", unit: "m"},
	{key: "distanceMinutes", label: "Distanza al minuto", unit: "m/min"},
	{key: "distance16kmh", label: "Distanza >16 km/h", unit: "m"},
	{key: "distance1525kmh", label: "Distanza 15-25 km/h", unit: "m"},
	{key: "distance2025kms", label: "Distanza 20-25 km/h", unit: "m"},
	{key: "distance25kmh", label: "Distanza >25 km/h", unit: "m"},
	{key: "maxSpeed", label: "Velocità massima", unit: "km/h"},
	{key: "edPercent", label: "ED %", unit: "%"},
	{key: "nAccelerations3ms", label: "N° accelerazioni >3 m/s²", unit: ""},
	{key: "nDecelerations3ms", label: "N° decelerazioni >3 m/s²", unit: ""},
	{key: "distAccelerations3ms", label: "Distanza in accelerazione", unit: "m"},
	{key: "distDecelerations3ms", label: "Distanza in decelerazione", unit: "m"},
	{key: "amax", label: "Accelerazione max", unit: "m/s²"},
	{key: "imbalance", label: "Sbilanciamento", unit: ""},
	{key: "jumps", label: "Salti", unit: ""},
	{key: "diveRx", label: "Tuffi dx", unit: ""},
	{key: "diveLx", label: "Tuffi sx", unit: ""},
	{key: "recoveryPerc", label: "Recupero %", unit: "%"},
	{
		key: "recoveryBetweenIntenseActions",
		label: "Recupero tra azioni intense",
		unit: "",
	},
];

// Campi testuali liberi
export const GPS_STAT_TEXT_FIELDS = [
	{key: "totTime", label: "Tempo totale"},
	{key: "trPass", label: "TR Pass"},
];

export const GPS_STAT_FRACTION_LABEL = (fraction) =>
	GPS_FRACTION_OPTIONS.find((o) => o.value === fraction)?.label ??
	(fraction != null ? String(fraction) : "—");

// Form vuoto (valori stringa per gli input; conversione al salvataggio)
export const createGpsStatForm = () => {
	const form = {player: null, fraction: GPS_FRACTION_OPTIONS[0]};
	GPS_STAT_TEXT_FIELDS.forEach((f) => (form[f.key] = ""));
	GPS_STAT_METRICS.forEach((m) => (form[m.key] = ""));
	return form;
};

// Costruisce il body per l'API a partire dal form
export const buildGpsStatPayload = (form, matchId) => {
	const body = {
		matchId,
		playerId: form.player?.value ?? null,
		fraction: form.fraction?.value ?? 0,
	};
	GPS_STAT_TEXT_FIELDS.forEach((f) => {
		body[f.key] = form[f.key] ?? "";
	});
	GPS_STAT_METRICS.forEach((m) => {
		const v = form[m.key];
		body[m.key] = v === "" || v == null ? 0 : Number(v);
	});
	return body;
};
